// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"f7d9a0f4","798":"834cfaa7","861":"834cfaa7"}[chunkId] + ".chunk.css";
};